import { Routes } from '@angular/router';

import { authGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth/login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
    title: 'Iniciar sesión',
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        title: 'Resumen',
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: 'sellers',
        loadChildren: () =>
          import('./features/sellers/sellers.routes').then((m) => m.SELLERS_ROUTES),
      },
      {
        path: 'catalog',
        loadChildren: () =>
          import('./features/catalog/catalog.routes').then((m) => m.CATALOG_ROUTES),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./features/orders/orders.routes').then((m) => m.ORDERS_ROUTES),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then((m) => m.PAYMENTS_ROUTES),
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./features/support/support.routes').then((m) => m.SUPPORT_ROUTES),
      },
      {
        path: 'ratings',
        loadChildren: () =>
          import('./features/ratings/ratings.routes').then((m) => m.RATINGS_ROUTES),
      },
      {
        path: 'banners',
        loadComponent: () =>
          import('./features/banners/banner-list/banner-list.component').then(
            (m) => m.BannerListComponent,
          ),
        title: 'Banners',
      },
      {
        path: 'workshops',
        loadComponent: () =>
          import('./features/workshops/workshop-list/workshop-list.component').then(
            (m) => m.WorkshopListComponent,
          ),
        title: 'Talleres',
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/notifications-admin.component').then(
            (m) => m.NotificationsAdminComponent,
          ),
        title: 'Notificaciones',
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./features/reports/reports.component').then((m) => m.ReportsComponent),
        title: 'Reportes',
      },
      {
        path: 'audit',
        loadComponent: () =>
          import('./features/audit/audit-log.component').then((m) => m.AuditLogComponent),
        title: 'Auditoría',
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/settings.component').then((m) => m.SettingsComponent),
        title: 'Configuración',
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
